"use strict";

module.exports.SliderConfig = {
  fullscreen: true,
  slideInterval: 10000,
  dotNavigationActiveClass: "fa fa-dot-circle-o",
  dotNavigationInActiveClass: "fa fa-circle-o",
  slides: [
    {
      path: "/",
      type: "large",
      images: [
        {
          id: 0,
          image: "naturstein-kueche-2.jpg",
          title: "Inspiration beginnt bei uns",
          subtitle:
            "Besuchen Sie uns in unserer Ausstellung und lassen Sie sich von der vielfältigen Auswahl inspirieren!"
        },
        { id: 1, image: "naturstein-treppe.jpg" },
        { id: 2, image: "naturstein-bad.jpg" },
        {
          id: 3,
          image: "naturstein-outdoor-kueche.jpg",
          title: "Ihr Partner in Sachen Steine",
          subtitle:
            "Mit über 50 Jahren Erfahrung im Bereich der Verarbeitung von Naturstein, Quarzstein und Keramik stehen wir Ihnen als verlässlicher Partner bis über das Projektende hinaus stets zur Seite!"
        },
        { id: 4, image: "naturstein-waschtisch.jpg" },
        {
          id: 5,
          image: "naturstein-kueche-4.jpg",
          title: "Wertvolle Schönheit die lange bleibt",
          subtitle:
            "Wir verarbeiten ausschließlich hochwertige Materialien und fertigen so Produkte für die Ewigkeit!"
        },
        { id: 6, image: "naturstein-bad-2.jpg" },
        { id: 7, image: "naturstein-kueche.jpg" }
      ]
    },
    {
      path: "",
      type: "large",
      images: [
        {
          id: 0,
          image: "naturstein-kueche-2.jpg",
          title: "Inspiration beginnt bei uns",
          subtitle:
            "Besuchen Sie uns in unserer Ausstellung und lassen Sie sich von der vielfältigen Auswahl inspirieren!"
        },
        { id: 1, image: "naturstein-treppe.jpg" },
        { id: 2, image: "naturstein-bad.jpg" },
        {
          id: 3,
          image: "naturstein-outdoor-kueche.jpg",
          title: "Ihr Partner in Sachen Steine",
          subtitle:
            "Mit über 50 Jahren Erfahrung im Bereich der Verarbeitung von Naturstein, Quarzstein und Keramik stehen wir Ihnen als verlässlicher Partner bis über das Projektende hinaus stets zur Seite!"
        },
        { id: 4, image: "naturstein-waschtisch.jpg" },
        {
          id: 5,
          image: "naturstein-kueche-4.jpg",
          title: "Wertvolle Schönheit die lange bleibt",
          subtitle:
            "Wir verarbeiten ausschließlich hochwertige Materialien und fertigen so Produkte für die Ewigkeit!"
        },
        { id: 6, image: "naturstein-bad-2.jpg" },
        { id: 7, image: "naturstein-kueche.jpg" }
      ]
    },
    {
      path: "/impressum",
      type: "small",
      images: [{ id: 0, image: "impressum.jpg" }]
    },
    {
      path: "/ueber-uns",
      type: "small",
      images: [{ id: 0, image: "ueber-uns.jpg", title: "Wie alles begann..." }]
    },
    {
      path: "/unser-team",
      type: "large",
      images: [{ id: 0, image: "IMG_9825_low.jpg" }]
    },
    {
      path: "/unsere-werkstatt",
      type: "small",
      images: [{ id: 0, image: "IMG_9867_low.jpg" }]
    },
    {
      path: "/material/materialsuche",
      type: "small",
      images: [{ id: 0, image: "ueber-uns.jpg" }]
    },
    {
      path: "/material/natursteine-und-kunststeine",
      type: "small",
      images: [{ id: 0, image: "ueber-uns.jpg" }]
    },
    {
      path: "/material/weichgesteine",
      type: "small",
      images: [{ id: 0, image: "slider_weichgesteine.jpg" }]
    },
    {
      path: "/material/granit-und-hartgesteine",
      type: "small",
      images: [{ id: 0, image: "slider_hartgesteine.jpg" }]
    },
    {
      path: "/material/quarzkomposit",
      type: "small",
      images: [{ id: 0, image: "slider_quarzkomposit.jpg" }]
    },
    {
      path: "/material/keramik",
      type: "small",
      images: [{ id: 0, image: "slider_keramik.jpg" }]
    },
    {
      path: "/naturstein-ausstellung",
      type: "small",
      images: [{ id: 0, image: "slider_ausstellung.jpg" }]
    },
    {
      path: "/kontakt",
      type: "small",
      images: [
        {
          id: 0,
          image: "kontakt.jpg",
          title: "Wir freuen uns über ihre Anfrage!"
        }
      ]
    },
    {
      path: "/service",
      type: "small",
      images: [
        { id: 0, image: "service.jpg", title: "Wir sind gerne für Sie da" }
      ]
    },
    {
      path: "/leistungen/ueberblick",
      type: "small",
      images: [
        {
          id: 0,
          image: "leistungen.jpg",
          title: "Eine Vielfalt an Möglichkeiten – Naturstein passt überall"
        }
      ]
    },
    {
      path: "/datenschutz",
      type: "small",
      images: [
        {
          id: 0,
          image: "datenschutz.jpg",
          title: "Denn Sicherheit geht vor..."
        }
      ]
    },
    {
      path: "/leistungen/naturstein-kuechenarbeitsplatten",
      type: "small",
      images: [{ id: 0, image: "naturstein-kuechenarbeitsplatte.jpg" }]
    },
    {
      path: "/leistungen/naturstein-boeden",
      type: "small",
      images: [{ id: 0, image: "naturstein-boden.jpg" }]
    },
    {
      path: "/leistungen/naturstein-fensterbank",
      type: "small",
      images: [{ id: 0, image: "slider_fensterbank.jpg" }]
    },
    {
      path: "/leistungen/naturstein-treppen",
      type: "small",
      images: [{ id: 0, image: "naturstein-treppe.jpg" }]
    },
    {
      path: "/leistungen/naturstein-waschtische-und-baeder",
      type: "small",
      images: [{ id: 0, image: "naturstein-bad-2.jpg" }]
    },
    {
      path: "/leistungen/naturstein-eingangsbereich",
      type: "small",
      images: [{ id: 0, image: "naturstein-eingangsbereich.jpg" }]
    },
    {
      path: "/leistungen/naturstein-tische-und-theken",
      type: "small",
      images: [{ id: 0, image: "naturstein-theke.jpg" }]
    },
    {
      path: "/leistungen/individuelle-naturstein-produkte",
      type: "small",
      images: [{ id: 0, image: "individuelle-produkte.jpg" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/slider.config.js